import * as types from "../constants/ActionTypes";
import update from "immutability-helper";

const initialState = {
  OutgoingTripList: [],
  IncomingTripList: [],
  outgoingDestinationTrips: [],
  incomingDestinationTrips: [],
  selectedOutgoingTrip: null,
  selectedIncomingTrip: null,

  searchStartDay: null,
  searchEndDay: null,
  searchDeparturePortCode: null,
  searchArrivalPortCode: null,

  userSelectedDepartureTrip: false,
  userSelectedReturnTrip: false
};

export default function searchItineraries(state = initialState, action) {
  switch (action.type) {
    case types.SET_OUTGOING_TRIPS:
      return update(state, { OutgoingTripList: { $set: action.tripList } });
    case types.SET_INCOMING_TRIPS:
      return update(state, { IncomingTripList: { $set: action.tripList } });
    case types.SET_OUTGOING_DESTINATION_TRIPS:
      return update(state, {
        outgoingDestinationTrips: { $set: action.tripList }
      });
    case types.SET_INCOMING_DESTINATION_TRIPS:
      return update(state, {
        incomingDestinationTrips: { $set: action.tripList }
      });
    case types.SELECT_OUTGOING_TRIP:
      return update(state, {
        selectedOutgoingTrip: { $set: action.outgoingTrip }
      });
    case types.SELECT_INCOMING_TRIP:
      return update(state, {
        selectedIncomingTrip: { $set: action.incomingTrip }
      });
    case types.SET_SEARCH_PARAMETERS:
      return update(state, {
        searchStartDay: { $set: action.searchStartDay },
        searchEndDay: { $set: action.searchEndDay },
        searchDeparturePortCode: { $set: action.searchDeparturePortCode },
        searchArrivalPortCode: { $set: action.searchArrivalPortCode }
      });
    case types.SET_USER_SELECTED_DEPARTURE_TRIP:
      return update(state, {
        userSelectedDepartureTrip: { $set: action.hasUserSelectedDepartureTrip }
      });
    case types.SET_USER_SELECTED_RETURN_TRIP:
      return update(state, {
        userSelectedReturnTrip: { $set: action.hasUserSelectedReturnTrip }
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_itineraries.js